import { render, staticRenderFns } from "./Advertisements.vue?vue&type=template&id=0dc776fa"
import script from "./Advertisements.vue?vue&type=script&lang=js"
export * from "./Advertisements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports